import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy dispatch-board path. The board now lives at /dashboard/dispatch
// (the operational cockpit) — redirect so old links/bookmarks land there.
export const Route = createFileRoute('/_dashboard/dashboard/board')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/dispatch',
      search: {
        date: undefined,
        // Leave the colour mode unset so the route default (Job type) applies —
        // pinning `status` here stuck in the URL and hid the job-type colours.
        colorBy: undefined,
        map: 'off',
        bookingId: undefined,
        territoryId: undefined,
        jobTypeId: undefined,
        businessUnitId: undefined,
        priority: undefined,
        origin: undefined,
        exceptions: undefined,
      },
      replace: true,
    });
  },
});
